import styled from "styled-components";

export const Input = styled.input`
  background: white;
  border: none;
  border-radius: 3px;
  outline: none;
  font-size: large;
  display: inline-block;
  width: 100%;
  color: #474c58;
  font-weight: 400;
  &::-webkit-input-placeholder {
    font-weight: 100;
    font-style: italic;
    color: #474c58;
  }
`;

export const Wrapper = styled.div`
  background: white;
  box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.05);
  font-family: "Open Sans", sans-serif;
  height: 111px;
  overflow-y: auto;
  font-weight: 400;
  border-radius: 7px;
  padding: 10px;
  font-size: large;
  position: absolute;
  left: 49%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 97%;
`;
